<template>
  <div class="text-xs-center">
    <div>
      <a v-if="index > 0" href="javascript:void(0)" @click="$emit('onMove', 'up')">
        <span class="fas fa-caret-up"></span>
      </a>
    </div>
    <div>
      <a v-if="index < lastIndex" href="javascript:void(0)" @click="$emit('onMove', 'down')">
        <span class="fas fa-caret-down"></span>
      </a>
    </div>
    <slot></slot>&nbsp;
  </div>
</template>

<script>
export default {
  props: ['index', 'max'],
  computed: {
    lastIndex: function() {
      return this.max - 1
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/MoveVertical.vue